module.exports = __webpack_public_path__ + "static/media/table_tennis.64d3bc19.svg";